<template>
  <div id="contenedor-adjudicaciones-default">
    <v-container fluid>
      <v-card
        class="mb-4"
        flat>
        <v-card-text>
          <titulo-tool-bar></titulo-tool-bar>
          <tool-bar
            class="mb-4"
            :filtros="filtros">
          </tool-bar>
        </v-card-text>
      </v-card>
      <v-card flat>
        <v-card-text>
          <listado
            :listadoAdjudicacionesDirectas="getListadoAdjudicacionesDirectas"
            :cargando="$apollo.queries.adjudicacionesDirectas.loading"
            :paginacion="getPaginacionAdjudicaciones"
            @cambiar-pagina="cambiarPagina"
            @cambiar-limite="cambiarLimite"></listado>
        </v-card-text>
      </v-card>
    </v-container>
    <v-dialog
      v-model="mostrarVentanaRegistrarNuevaAdjudicacionDirecta"
      :width="!$vuetify.breakpoint.mobile ? '90%' : '90%'">
      <registrar-nueva-adjudicacion-directa
        v-if="mostrarVentanaRegistrarNuevaAdjudicacionDirecta"
        v-on:cerrar="cerrarRegistrarNuevaAdjudicacionDirecta">
      </registrar-nueva-adjudicacion-directa>
    </v-dialog>
    <v-dialog
      v-if="estaAdjudicacionDirecta"
      v-model="mostrarVentanaEditarAdjudicacionDirecta"
      :width="!$vuetify.breakpoint.mobile ? '80%' : '90%'">
      <editar-adjudicacion-directa
        :adjudicacionDirectaEditar="estaAdjudicacionDirecta"
        v-on:cerrar="cerrarEditarAdjudicacionDirecta">
      </editar-adjudicacion-directa>
    </v-dialog>
    <v-dialog
      v-if="estaAdjudicacionDirecta"
      v-model="mostrarVentanaEliminarAdjudicacionDirecta"
      :width="!$vuetify.breakpoint.mobile ? '450' : '90%'">
      <eliminar-adjudicacion-directa
        :adjudicacionDirectaEliminar="estaAdjudicacionDirecta"
        v-on:cerrar="cerrarRemoverAdjudicacionDirecta">
      </eliminar-adjudicacion-directa>
    </v-dialog>
  </div>
</template>

<script>
import ADJUDICACIONES_DIRECTAS from '@/graphql/querys/administracion/adjudicaciones/adjudicacionesDirectas.gql';
import RegistrarNuevaAdjudicacionDirecta from '@/components/administracion/adjudicaciones/Nueva.vue';
import EditarAdjudicacionDirecta from '@/components/administracion/adjudicaciones/Editar.vue';
import EliminarAdjudicacionDirecta from '@/components/administracion/adjudicaciones/Eliminar.vue';
import eventBus from '@/helpers/eventBus';
import ToolBar from './ToolBar.vue';
import Listado from './listado/Main.vue';
import TituloToolBar from './TituloToolBar.vue';

export default {
  name: 'AdjudicacionesDefault',
  components: {
    TituloToolBar,
    RegistrarNuevaAdjudicacionDirecta,
    EditarAdjudicacionDirecta,
    EliminarAdjudicacionDirecta,
    ToolBar,
    Listado,
  },
  data() {
    return {
      mostrarVentanaRegistrarNuevaAdjudicacionDirecta: false,
      mostrarVentanaEditarAdjudicacionDirecta: false,
      mostrarVentanaEliminarAdjudicacionDirecta: false,
      estaAdjudicacionDirecta: null,
      filtros: {
        ejercicio: new Date().getFullYear(),
        buscarTexto: '',
        idContratista: null,
        pagina: 1,
        limite: 20,
      },
    };
  },
  apollo: {
    adjudicacionesDirectas: {
      query: ADJUDICACIONES_DIRECTAS,
      variables() {
        return {
          ejercicio: this.filtros.ejercicio,
          idContratista: this.filtros.idContratista || null,
          pagina: this.filtros.pagina,
          limite: this.filtros.limite,
        };
      },
      skip() {
        return !this.filtros.ejercicio;
      },
    },
  },
  watch: {
    'filtros.ejercicio': function filtroEjercicio() {
      this.aplicarFiltrosServidor();
    },
    'filtros.idContratista': function filtroContratista() {
      this.aplicarFiltrosServidor();
    },
  },
  mounted() {
    eventBus.$on('editar-adjudicacion-directa', (adjudicacionDirecta) => {
      this.estaAdjudicacionDirecta = adjudicacionDirecta;
      this.mostrarVentanaEditarAdjudicacionDirecta = true;
    });
    eventBus.$on('eliminar-adjudicacion-directa', (adjudicacionDirecta) => {
      this.estaAdjudicacionDirecta = adjudicacionDirecta;
      this.mostrarVentanaEliminarAdjudicacionDirecta = true;
    });
  },
  methods: {
    cerrarRegistrarNuevaAdjudicacionDirecta() {
      this.mostrarVentanaRegistrarNuevaAdjudicacionDirecta = false;
    },
    cerrarEditarAdjudicacionDirecta() {
      this.mostrarVentanaEditarAdjudicacionDirecta = false;
      this.estaAdjudicacionDirecta = null;
    },
    cerrarRemoverAdjudicacionDirecta() {
      this.mostrarVentanaEliminarAdjudicacionDirecta = false;
      this.estaAdjudicacionDirecta = null;
    },
    async refrescarListado() {
      if (!this.$apollo.queries.adjudicacionesDirectas) return;
      await this.$apollo.queries.adjudicacionesDirectas.refetch();
    },
    aplicarFiltrosServidor() {
      if (!this.filtros.ejercicio) return;

      if (this.filtros.pagina !== 1) {
        this.filtros.pagina = 1;
        this.$nextTick(() => {
          this.refrescarListado();
        });
        return;
      }

      this.refrescarListado();
    },
    cambiarPagina(pagina) {
      if (this.filtros.pagina === pagina) return;
      this.filtros.pagina = pagina;
      this.refrescarListado();
    },
    cambiarLimite(limite) {
      if (this.filtros.limite === limite) return;
      this.filtros.limite = limite;
      this.filtros.pagina = 1;
      this.refrescarListado();
    },
  },
  computed: {
    getAdjudicacionesDirectas() {
      if (!this.adjudicacionesDirectas) return [];
      return this.adjudicacionesDirectas.datos || [];
    },
    getPaginacionAdjudicaciones() {
      if (!this.adjudicacionesDirectas || !this.adjudicacionesDirectas.paginacion) {
        return {
          total: 0,
          pagina: 1,
          limite: this.filtros.limite,
          totalPaginas: 1,
        };
      }

      return this.adjudicacionesDirectas.paginacion;
    },
    getListadoAdjudicacionesDirectas() {
      if (!this.getAdjudicacionesDirectas.length) return [];

      const textoBusqueda = this.$normalizacionTexto(this.filtros.buscarTexto || '').trim();
      if (!textoBusqueda) return this.getAdjudicacionesDirectas;

      return this.getAdjudicacionesDirectas.filter((adjudicacion) => {
        const campos = [
          adjudicacion.numeroContrato,
          adjudicacion.meta,
          adjudicacion.numeroDictamen,
          adjudicacion.contratista ? adjudicacion.contratista.nombreRazonSocial : '',
        ];

        return campos.some((campo) => this.$normalizacionTexto(campo || '').includes(textoBusqueda));
      });
    },
  },
};
</script>

<style lang="scss">

</style>
